---
title: EULA
published_time: 2024-08-11T14:30:00Z
og:
  title: EULA
  description: EasyPageGo's End User License Agreement.
---

# End User License Agreement (EULA) for EasyPageGo by L13o S.r.l

This End User License Agreement (“EULA”) is a legal agreement between you (the “User” or “You”) and L13o S.r.l, (“L13o S.r.l” or “We”) for the software application EasyPageGo (the “Software”). By installing or using the Software, you agree to be bound by the terms and conditions of this EULA. If you do not agree to these terms, do not install or use the Software.

## 1. License Grant:

### 1.1. License Terms

L13o S.r.l hereby grants you a non-exclusive, non-transferable, limited license to use the Software for your personal or internal business purposes in accordance with this EULA.

### 1.2. Installation

You may install and use the Software on a single Mac computer owned or controlled by you.

### 1.3. Restrictions

This license does not grant you any right to sublicense, distribute, or otherwise make the Software available to third parties.

## 2. Ownership and Intellectual Property:

### 2.1. Property Rights

The Software is licensed, not sold. L13o S.r.l retains all rights, title, and interest in and to the Software, including all copyrights, trademarks, and other intellectual property rights.

## 3. Use Restrictions:

### 3.1. Prohibited Actions

You may not:

- a) Modify, adapt, translate, reverse engineer, decompile, disassemble, or attempt to discover the source code of the Software.
- b) Remove, alter, or obscure any copyright, trademark, or other proprietary notices from the Software.
- c) Use the Software for any unlawful purpose or in any way that violates applicable laws or regulations.

## 4. Warranty Disclaimer:

### 4.1. No Warranty

THE SOFTWARE IS PROVIDED “AS IS” AND WITHOUT ANY WARRANTY, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.

### 4.2. Limitation

L13o S.r.l does not warrant that the Software will be error-free or that it will meet your specific requirements. You acknowledge that the use of the Software may be subject to interruptions and errors.

## 5. Governing Law and Jurisdiction:

### 5.1. Applicable Law

This EULA is governed by and construed in accordance with the laws of Italy, without regard to its conflict of law principles.

### 5.2. Jurisdiction

Any dispute arising out of or in connection with this EULA shall be subject to the exclusive jurisdiction of the courts of Italy.

## 6. Termination:

### 6.1. EULA Duration

This EULA is effective until terminated. You may terminate this EULA at any time by uninstalling the Software and destroying all copies of the Software in your possession.

### 6.2. Termination by L13o S.r.l

L13o S.r.l may terminate this EULA at any time if you fail to comply with any of its terms and conditions. Upon termination, you must uninstall the Software and destroy all copies of the Software in your possession.

## 7. Miscellaneous:

### 7.1. Entire Agreement

This EULA constitutes the entire agreement between you and L13o S.r.l regarding the Software and supersedes all prior agreements and understandings, whether written or oral.

### 7.2. Severability

If any provision of this EULA is found to be invalid or unenforceable, the remaining provisions of this EULA shall remain in full force and effect.

By installing or using the Software, you acknowledge that you have read, understood, and agreed to be bound by the terms and conditions of this EULA. If you do not agree to these terms, do not install or use the Software.
